import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useNotify, useRecommendContent } from 'hooks';

import ContentWidget from './ContentWidget';

const ShareThese: FC = () => {
  const notify = useNotify();
  const { t } = useTranslation();
  const { results, isInitialLoad } = useRecommendContent(
    { size: 4, results_from: 0 },
    {
      onError: notify.queryError,
    }
  );

  if (isInitialLoad) {
    return null;
  }

  return <ContentWidget results={results} title={t('sharing:shareThese')} />;
};

export default ShareThese;
